import { render } from "./Activities.vue?vue&type=template&id=0103484a&scoped=true"
import script from "./Activities.vue?vue&type=script&lang=js"
export * from "./Activities.vue?vue&type=script&lang=js"

import "./Activities.vue?vue&type=style&index=0&id=0103484a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0103484a"

export default script